module.exports = __webpack_public_path__ + "static/media/dashboard.4a41464e.svg";